var map = {
	"./account-search-outline.svg": 87576,
	"./activity.svg": 25880,
	"./ai-outline.svg": 5108,
	"./ai-unpin.svg": 5656,
	"./ai.svg": 33345,
	"./airplay.svg": 95059,
	"./alert-circle.svg": 51140,
	"./alert-octagon.svg": 8537,
	"./alert-triangle.svg": 6164,
	"./align-center.svg": 86540,
	"./align-justify.svg": 43221,
	"./align-left.svg": 46808,
	"./align-right.svg": 59975,
	"./aloha.svg": 90610,
	"./anchor.svg": 25960,
	"./aperture.svg": 94071,
	"./archive.svg": 4315,
	"./arrow-down-circle.svg": 31892,
	"./arrow-down-left.svg": 82251,
	"./arrow-down-right.svg": 84878,
	"./arrow-down.svg": 21655,
	"./arrow-left-circle.svg": 35733,
	"./arrow-left.svg": 17160,
	"./arrow-right-circle.svg": 98292,
	"./arrow-right.svg": 21015,
	"./arrow-up-circle.svg": 81045,
	"./arrow-up-left.svg": 24402,
	"./arrow-up-right.svg": 31689,
	"./arrow-up.svg": 29832,
	"./assignment-turned-in.svg": 79337,
	"./at-sign.svg": 42610,
	"./award.svg": 47006,
	"./bar-chart-2.svg": 11684,
	"./bar-chart.svg": 84021,
	"./battery-charging.svg": 33814,
	"./battery.svg": 14766,
	"./bell-off.svg": 34904,
	"./bell.svg": 47636,
	"./bluetooth.svg": 26459,
	"./bold.svg": 58702,
	"./book-open.svg": 23309,
	"./book.svg": 13580,
	"./bookmark-add.svg": 15273,
	"./bookmark-check.svg": 57280,
	"./bookmark-filled-check.svg": 30131,
	"./bookmark-filled-remove.svg": 17241,
	"./bookmark.svg": 45215,
	"./box.svg": 60290,
	"./briefcase.svg": 45525,
	"./building.svg": 58299,
	"./bullseye-arrow.svg": 17634,
	"./buyandsell.svg": 88212,
	"./calendar.svg": 63249,
	"./camera-off.svg": 17054,
	"./camera.svg": 90750,
	"./cast.svg": 55238,
	"./check-circle.svg": 63478,
	"./check-square.svg": 35019,
	"./check.svg": 75161,
	"./chevron-down.svg": 84893,
	"./chevron-left.svg": 10342,
	"./chevron-right.svg": 48869,
	"./chevron-up.svg": 78018,
	"./chevrons-down.svg": 14732,
	"./chevrons-left.svg": 68763,
	"./chevrons-right.svg": 64766,
	"./chevrons-up.svg": 6215,
	"./chrome.svg": 53485,
	"./circle.svg": 41031,
	"./clipboard.svg": 27647,
	"./clock.svg": 31635,
	"./cloud-drizzle.svg": 84167,
	"./cloud-lightning.svg": 54687,
	"./cloud-off.svg": 59046,
	"./cloud-rain.svg": 14673,
	"./cloud-snow.svg": 64846,
	"./cloud.svg": 69286,
	"./code.svg": 76512,
	"./codepen.svg": 3505,
	"./command.svg": 68322,
	"./compass.svg": 8633,
	"./copy.svg": 15152,
	"./corner-down-left.svg": 61345,
	"./corner-down-right.svg": 93772,
	"./corner-left-down.svg": 41583,
	"./corner-left-up.svg": 56064,
	"./corner-right-down.svg": 55986,
	"./corner-right-up.svg": 53089,
	"./corner-up-left.svg": 73788,
	"./corner-up-right.svg": 88771,
	"./cpu.svg": 5511,
	"./creation.svg": 80424,
	"./credit-card.svg": 94891,
	"./crop.svg": 73265,
	"./crosshair.svg": 25349,
	"./database.svg": 39012,
	"./delete.svg": 7914,
	"./disc.svg": 97784,
	"./dollar-sign.svg": 98101,
	"./down.svg": 68851,
	"./download-cloud.svg": 39651,
	"./download.svg": 17903,
	"./droplet.svg": 38911,
	"./edit-2.svg": 59698,
	"./edit-3.svg": 74339,
	"./edit.svg": 82951,
	"./entity-crud/default-search.svg": 84510,
	"./entity-crud/default.svg": 63937,
	"./entity-crud/ms-dynamics-search.svg": 69438,
	"./entity-crud/ms-dynamics.svg": 2177,
	"./external-link.svg": 48351,
	"./eye-off.svg": 86674,
	"./eye.svg": 89666,
	"./facebook.svg": 22351,
	"./fast-forward.svg": 92725,
	"./feather.svg": 45076,
	"./file-excel.svg": 25555,
	"./file-input.svg": 26614,
	"./file-magnify.svg": 98867,
	"./file-minus.svg": 90206,
	"./file-pdf-box.svg": 34692,
	"./file-plus.svg": 49526,
	"./file-text.svg": 93455,
	"./file.svg": 35485,
	"./film.svg": 55669,
	"./filter.svg": 20953,
	"./fit-page.svg": 57876,
	"./flag.svg": 47889,
	"./folder-minus.svg": 25876,
	"./folder-plus.svg": 69436,
	"./folder.svg": 65635,
	"./format-letter-matches.svg": 13291,
	"./gift.svg": 15193,
	"./git-branch.svg": 65530,
	"./git-commit.svg": 37945,
	"./git-merge.svg": 16730,
	"./git-pull-request.svg": 40267,
	"./github.svg": 90458,
	"./gitlab.svg": 91106,
	"./globe.svg": 45322,
	"./google.svg": 30838,
	"./grid.svg": 42095,
	"./grip-vertical.svg": 28370,
	"./hard-drive.svg": 58127,
	"./hash.svg": 28847,
	"./headphones.svg": 69022,
	"./heart.svg": 25613,
	"./help-circle.svg": 83095,
	"./help.svg": 44266,
	"./highlighter.svg": 54464,
	"./home.svg": 46550,
	"./image.svg": 45802,
	"./inbox.svg": 45733,
	"./info.svg": 42667,
	"./instagram.svg": 95557,
	"./italic.svg": 80971,
	"./key.svg": 76352,
	"./label-variant-outline.svg": 32906,
	"./layers.svg": 7377,
	"./layout.svg": 26321,
	"./life-buoy.svg": 81705,
	"./link-2.svg": 30498,
	"./link.svg": 96439,
	"./linkedin.svg": 22777,
	"./list.svg": 35151,
	"./loader.svg": 47250,
	"./lock.svg": 47106,
	"./log-in.svg": 90677,
	"./log-out.svg": 90220,
	"./mail.svg": 20510,
	"./map-pin.svg": 18949,
	"./map.svg": 95583,
	"./maximize-2.svg": 33920,
	"./maximize.svg": 42185,
	"./menu.svg": 61402,
	"./merx.svg": 15507,
	"./message-circle.svg": 82797,
	"./message-sent.svg": 11435,
	"./message-square.svg": 90880,
	"./mic-off.svg": 43512,
	"./mic.svg": 33012,
	"./minimize-2.svg": 50254,
	"./minimize.svg": 6571,
	"./minus-circle.svg": 37982,
	"./minus-square.svg": 73555,
	"./minus.svg": 28353,
	"./monitor.svg": 14135,
	"./moon.svg": 59236,
	"./more-horizontal.svg": 22985,
	"./more-vertical.svg": 21055,
	"./move.svg": 63240,
	"./music.svg": 35072,
	"./navigation-2.svg": 91220,
	"./navigation.svg": 93477,
	"./octagon.svg": 19564,
	"./package.svg": 88469,
	"./paperclip.svg": 3073,
	"./pause-circle.svg": 45299,
	"./pause.svg": 87203,
	"./percent.svg": 34610,
	"./phone-call.svg": 81482,
	"./phone-forwarded.svg": 26882,
	"./phone-incoming.svg": 95633,
	"./phone-missed.svg": 93857,
	"./phone-off.svg": 59477,
	"./phone-outgoing.svg": 29404,
	"./phone.svg": 35393,
	"./pie-chart.svg": 50228,
	"./pin-crossed.svg": 14948,
	"./pin-outline.svg": 86217,
	"./pin.svg": 42600,
	"./play-circle.svg": 44794,
	"./play.svg": 10317,
	"./plus-circle.svg": 75904,
	"./plus-square.svg": 88105,
	"./plus.svg": 15043,
	"./pocket.svg": 84433,
	"./power.svg": 1670,
	"./printer.svg": 15313,
	"./radio.svg": 6768,
	"./refresh-ccw.svg": 20722,
	"./refresh-cw.svg": 29923,
	"./repeat.svg": 43429,
	"./rewind.svg": 29326,
	"./rocket-launch.svg": 77,
	"./rocket.svg": 73099,
	"./rotate-ccw.svg": 56944,
	"./rotate-cw.svg": 56105,
	"./rss.svg": 54797,
	"./save.svg": 26172,
	"./scissors.svg": 85070,
	"./seao.svg": 49991,
	"./search.svg": 9679,
	"./send.svg": 64809,
	"./sent.svg": 46489,
	"./server.svg": 42314,
	"./settings.svg": 61076,
	"./share-2.svg": 6897,
	"./share.svg": 32844,
	"./shield-off.svg": 9904,
	"./shield.svg": 55948,
	"./shopping-bag.svg": 17966,
	"./shopping-cart.svg": 98078,
	"./shuffle.svg": 25790,
	"./sidebar.svg": 34513,
	"./skip-back.svg": 10186,
	"./skip-forward.svg": 98570,
	"./slack.svg": 70617,
	"./slash.svg": 59642,
	"./sliders.svg": 69515,
	"./smartphone.svg": 50874,
	"./speaker.svg": 74762,
	"./square-filled.svg": 4211,
	"./square.svg": 7542,
	"./stop-circle-2.svg": 22941,
	"./stop-circle.svg": 75600,
	"./sun.svg": 90999,
	"./sunrise.svg": 7624,
	"./sunset.svg": 18665,
	"./sync/default-failed.svg": 53914,
	"./sync/default-in-progress.svg": 19928,
	"./sync/default-success.svg": 39629,
	"./sync/default.svg": 47868,
	"./sync/ms-business-central-failed.svg": 69770,
	"./sync/ms-business-central-in-progress.svg": 52680,
	"./sync/ms-business-central-success.svg": 51978,
	"./sync/ms-business-central.svg": 31980,
	"./sync/ms-dynamics-custom-failed.svg": 96302,
	"./sync/ms-dynamics-custom-in-progress.svg": 86700,
	"./sync/ms-dynamics-custom-success.svg": 5430,
	"./sync/ms-dynamics-custom.svg": 21328,
	"./sync/ms-dynamics-failed.svg": 23642,
	"./sync/ms-dynamics-in-progress.svg": 86552,
	"./sync/ms-dynamics-success.svg": 42490,
	"./sync/ms-dynamics.svg": 13628,
	"./sync/zoho-failed.svg": 41923,
	"./sync/zoho-in-progress.svg": 84519,
	"./sync/zoho-success.svg": 50285,
	"./sync/zoho.svg": 58315,
	"./tablet.svg": 73679,
	"./tag.svg": 48989,
	"./target.svg": 5244,
	"./teach.svg": 41002,
	"./telescope.svg": 46333,
	"./terminal.svg": 54807,
	"./text.svg": 58470,
	"./thermometer.svg": 47521,
	"./thumbs-down.svg": 68061,
	"./thumbs-up.svg": 19202,
	"./thunder.svg": 79807,
	"./toggle-left.svg": 85815,
	"./toggle-right.svg": 2226,
	"./trash-2.svg": 34550,
	"./trash.svg": 1955,
	"./trending-down.svg": 82541,
	"./trending-up.svg": 41522,
	"./triangle.svg": 11099,
	"./truck.svg": 80212,
	"./tv.svg": 37505,
	"./twitter.svg": 50664,
	"./type.svg": 41755,
	"./umbrella.svg": 65083,
	"./underline.svg": 38225,
	"./unlock.svg": 88707,
	"./up.svg": 80332,
	"./upload-cloud.svg": 88532,
	"./upload.svg": 7568,
	"./user-check.svg": 36993,
	"./user-minus.svg": 27065,
	"./user-plus.svg": 72299,
	"./user-x.svg": 12121,
	"./user.svg": 41138,
	"./users.svg": 34189,
	"./verified-badge.svg": 9757,
	"./verified.svg": 68475,
	"./video-off.svg": 23580,
	"./video.svg": 13656,
	"./voicemail.svg": 72450,
	"./volume-1.svg": 33883,
	"./volume-2.svg": 83144,
	"./volume-x.svg": 87282,
	"./volume.svg": 58881,
	"./vote.svg": 52515,
	"./watch.svg": 38084,
	"./wifi-off.svg": 5472,
	"./wifi.svg": 83452,
	"./wind.svg": 36241,
	"./x-circle.svg": 49566,
	"./x-square.svg": 45267,
	"./x.svg": 62049,
	"./youtube.svg": 46158,
	"./zap-off.svg": 78908,
	"./zap.svg": 57240,
	"./zoom-in.svg": 71526,
	"./zoom-out.svg": 61985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;